import KunLoading7 from './src/index'

KunLoading7.install = function (Vue){
	Vue.component(KunLoading7.name, KunLoading7);
}

export default KunLoading7;
